import { useTranslation } from "react-i18next"
import { Button, Card, CardBody, CardHeader, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import GetApiCOC from "../../@fake-db/ApiCOC"
import { getUserData } from "../../auth/utils"
import axios from "axios"

const FormConfirm = ({ setFormConfirm, formConfirm, setBlockAllClosures }) => {

  const { t } = useTranslation()
  
  
  const base64ToString = (response) => { 
    if (response.data.Result === "true" && response.data.response_data.length > 0) {
      return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
    } else {
      return []
    }
  } 

  const CortaInfo = (data) => {
    const reducedData = data.map(item => {
      return {
        id_closure: item.id_closure,
        user_closure: item.user_closure,
        user_uptake: item.user_uptake,
        closure_status: item.closure_status,
        client_name: item.client_data.name,
        property_data: item.property_data.address
      }
    })
    localStorage.setItem('dataAllClosure', JSON.stringify(reducedData))
    setFormConfirm(false)
  }

  const onClick = async () => {

    setFormConfirm(false)
    setBlockAllClosures(true)

    const user = getUserData()

    const body = {
      office_id: user.usercoc.office_id,
      user_id  : user.usercoc.user_id,
      role     : user.usercoc.role,
      superuser: user.usercoc.superuser
    }
    
    const configws = {

      method: 'post',
      url: GetApiCOC('getAllClosure'),
      headers: {
        Accept: 'application/json',
        obrientoken: user.token
      },
      params: body
    }
  
    await axios(configws)
    .then((response) => {
      const data = base64ToString(response)
      CortaInfo(data)
    })
    .catch((error) => {
      console.log('Error', error.message)
    })

    setBlockAllClosures(false)
  }

  const handleCancel = () => {
    setFormConfirm(false)
  }

  return (
    <Modal isOpen={formConfirm} className='modal-dialog-centered' modalClassName='secondary' key='form-add-loan-equipment'>
      <ModalHeader><h4>Recargar All Closures</h4></ModalHeader>
      <ModalBody>
        <div className='d-flex align-items-center justify-content-center'>
          <span>Esto podria tomar un tiempo, desea continuar?</span>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button className="me-1" color="secondary" type="submit" onClick={onClick}>
          {t('Sincronizar')}
        </Button>
        <Button outline color="danger" type="reset" onClick={handleCancel}>
          {t('Cancelar')}
        </Button>   
      </ModalFooter>  
    </Modal>
  )

}

export default FormConfirm